/* @flow */

import { useState, useRef, useCallback, useEffect } from "react";
import { useData } from "crustate/react";
import { MODE } from "state/view-mode";
import { ViewModeData } from "data";

const MIN_SCROLL_DIFF_PIXEL = 10;

const useHeaderScroll = (headerHeight: number): { isHidden: boolean, isScrolled: boolean } => {
  const viewMode = useData(ViewModeData);
  const scrollPositionY = useRef(0);
  const [isHidden, setIsHidden] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const scrolling = useRef();

  const resetScroll = useCallback(() => {
    clearTimeout(scrolling.current);
    scrolling.current = null;
  }, []);

  const scrollListener = useCallback(() => {
    if (!scrolling.current) {
      scrollPositionY.current = window.scrollY;
    }

    if (scrolling.current &&
      window.scrollY < (scrollPositionY.current - MIN_SCROLL_DIFF_PIXEL)) {
      setIsHidden(false);
    }
    else if (scrolling.current &&
      window.scrollY > (scrollPositionY.current + MIN_SCROLL_DIFF_PIXEL)) {
      setIsHidden(true);
    }

    if (window.scrollY > headerHeight) {
      setIsScrolled(true);
    }
    else {
      setIsScrolled(false);
    }

    clearTimeout(scrolling.current);
    scrolling.current = setTimeout(resetScroll, 20);
  }, [setIsHidden, scrolling, resetScroll, scrollPositionY, setIsScrolled]);

  useEffect(() => {
    window.addEventListener("scroll", scrollListener, { passive: true });

    return () => {
      window.removeEventListener("scroll", scrollListener);
    };
  }, [scrollListener]);

  return {
    isHidden: (viewMode === MODE.NORMAL || viewMode === MODE.CART) && isScrolled && isHidden,
    isScrolled,
  };
};

export default useHeaderScroll;
